<template>
    <v-navigation-drawer
        v-model="drawer"
        app
        right
        temporary dark
        :clipped="$vuetify.breakpoint.lgAndUp"
    >
        <v-list dense>
        <template>
            <v-list-item :to="{name: 'Home'}">
            <v-list-item-action>
                <v-icon>home</v-icon>
            </v-list-item-action>
            <v-list-item-title>
                Inicio
            </v-list-item-title>
            </v-list-item>
        </template>
        <template>
            <v-list-item :to="{name: 'Cafe'}">
            <v-list-item-action>
                <v-icon>free_breakfast</v-icon>
            </v-list-item-action>
            <v-list-item-title>
                Café
            </v-list-item-title>
            </v-list-item>
        </template>
        <template>
            <v-list-item :to="{name: 'Bar'}">
            <v-list-item-action>
                <v-icon>local_dining</v-icon>
            </v-list-item-action>
            <v-list-item-title>
                Bar
            </v-list-item-title>
            </v-list-item>
        </template>
        <!-- <template>
            <v-list-item :to="{name: 'Blog'}">
            <v-list-item-action>
                <v-icon>local_dining</v-icon>
            </v-list-item-action>
            <v-list-item-title>
                Blog
            </v-list-item-title>
            </v-list-item>
        </template> -->
        <template>
            <v-list-item :to="{name: 'Contact'}">
            <v-list-item-action>
                <v-icon>contact_mail</v-icon>
            </v-list-item-action>
            <v-list-item-title>
                Contacto
            </v-list-item-title>
            </v-list-item>
        </template>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
export default {
    data: () => ({
        
    }),
    props: {
        drawer: Boolean
    },
}
</script>
<style lang="scss" scoped>
    
</style>